// extracted by mini-css-extract-plugin
module.exports = {"backToTopButton":"BackToTopButton_backToTopButton__oTPAP"};